/**
 * CUALoopDetectedBanner — critical alert banner when agent loop is detected via SSE
 * Reference: TASK-UI-CU-007-2, SOL-UI-CU-007
 */

import React from 'react';
import { useCUALoopEvents } from '../hooks/useCUALoopEvents';

export function CUALoopDetectedBanner() {
  const { loopEvent, dismiss } = useCUALoopEvents();

  if (!loopEvent) return null;

  return (
    <div
      role="alert"
      data-testid="cua-loop-detected-banner"
      className="fixed top-4 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-3 bg-status-error text-white px-4 py-3 rounded-xl shadow-lg border border-status-error/70 max-w-lg w-full mx-4"
    >
      <span className="text-lg shrink-0" aria-hidden="true">🔄</span>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold">Phát hiện Agent lặp vô hạn</p>
        <p className="text-xs opacity-90 truncate" title={loopEvent.reason}>
          {loopEvent.reason}
        </p>
      </div>
      <button
        data-testid="cua-loop-banner-dismiss-btn"
        type="button"
        onClick={dismiss}
        className="shrink-0 text-white/80 hover:text-white text-lg leading-none px-1 transition-colors"
        aria-label="Đóng thông báo loop"
      >
        ×
      </button>
    </div>
  );
}
